var React = require('react');

function Loveseat (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 288v-64a64.06 64.06 0 0 0-64-64H64a96 96 0 0 1 96-96h192a96 96 0 0 1 96 96h-32a64.06 64.06 0 0 0-64 64v64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 256a63.84 63.84 0 0 1-32 55.1V432a16 16 0 0 1-16 16h-64a16 16 0 0 1-16-16v-16H128v16a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V311.1A63.79 63.79 0 0 1 64 192h32a32 32 0 0 1 32 32v96h256v-96a32 32 0 0 1 32-32h32a64.06 64.06 0 0 1 64 64z","className":"fa-primary","key":2})]);
}

Loveseat.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Loveseat;

Loveseat.default = Loveseat;
